export enum InstructionResponseEnum {
  VerbalizedUnderstanding = 1,
  ReturnedDemonstration = 2,
  RequiresMoresEducation = 3,
  UnableToComprehend = 4
}

export const InstructionResponseOptions = [
{ id: 1, label: 'Verbalized Understanding' },
{ id: 2, label: 'Returned Demonstration' },
{ id: 3, label: 'Requires More Education' },
{ id: 4, label: 'Unable to Comprehend' }
];
